import CourseItems from "../../../components/courses/courses-items";
import Form from "../../../components/form/Form";
import CourseContainer from "../../../components/courses/courses-container";
import {
  updateCourse,
  getCourses,
  deleteCourse,
} from "../../../apis/coursesApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";

import React from "react";

function Courses(props) {
  const [state, setState] = useState({
    isEditing: false,
    courses: [],
    editCourse: null,
    editLoading: false,
    error: null,
  });

  useEffect(() => {
    loadPosts();
    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getCourses();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          courses: [],
          editCourse: null,
          editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        courses: data.courses,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedCourse = {
        ...prevState.courses.find((p) => p._id === postId),
      };
      return {
        ...prevState,
        isEditing: true,
        editCourse: loadedCourse,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: false, editCourse: null, error: null };
    });
  };

  const finishEditHandler = async (courseData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });

    // const formData = new FormData();

    // formData.append("courseName", postData.courseName);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);
    let courseId = state.editCourse ? state.editCourse._id : null;
    const { data, error } = await updateCourse(
      props.token,
      courseId,
      courseData
    );
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editCourse: null,
          editLoading: false,
          error: error,
        };
      });
    }
    const course = {
      _id: data.course._id,
      name: data.course.name,
      description: data.course.description,
    };

    setState((prevState) => {
      let updatedCourses;
      if (prevState.editCourse) {
        updatedCourses = prevState.courses.map((c) =>
          c._id === course._id ? course : c
        );
      } else {
        updatedCourses = prevState.courses.concat(course);
      }
      return {
        ...prevState,
        courses: updatedCourses,
        isEditing: false,
        editCourse: null,
        editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });
    const { data, error } = await deleteCourse(props.token, postId);

    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editCourse: null,
          editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();

    setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editCourse}
        page={"Course"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <CourseContainer onAddCourse={newPostHandler} isAuth={props.isAuth}>
        {state.courses.map((course) => (
          <CourseItems
            onStartEdit={startEditPostHandler.bind(this, course._id)}
            key={course._id}
            name={course.name}
            description={course.description}
            onDelete={deletePostHandler.bind(this, course._id)}
            isAuth={props.isAuth}
          />
        ))}
      </CourseContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Courses;
